var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
var primary = getComputedStyle(document.documentElement)
    .getPropertyValue("--primary")
    .trim();
var tabStyle = {
    fontFamily: "inherit",
    textTransform: "capitalize",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    textAlign: "left",
    "&.Mui-selected": {
        color: primary,
        fontWeight: "bold",
    },
    "&.MuiTabs-indicator": {
        backgroundColor: primary,
    },
};
function a11yProps(index) {
    return {
        id: "vertical-tab-".concat(index),
        "aria-controls": "vertical-tabpanel-".concat(index),
    };
}
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = __rest(props, ["children", "value", "index"]);
    return (_jsx("div", __assign({ role: "tabpanel", hidden: value !== index, id: "vertical-tabpanel-".concat(index), "aria-labelledby": "vertical-tab-".concat(index) }, other, { children: value === index && (_jsx(Box, __assign({ sx: { p: 3 } }, { children: _jsx(Typography, __assign({ component: "div" }, { children: children })) }))) })));
}
export default function VerticalTab(props) {
    var _a = React.useState(0), value = _a[0], setValue = _a[1];
    var handleChange = function (event, newValue) {
        props.setStateCallback(newValue);
        setValue(newValue);
    };
    return (_jsxs(Box, __assign({ sx: {
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            minHeight: 0,
            width: "100%",
        } }, { children: [_jsxs(Box, __assign({ sx: {
                    display: "flex",
                    flexDirection: "column",
                    borderRight: 1,
                    borderColor: "divider",
                    width: 250,
                    minWidth: 250,
                } }, { children: [_jsx(Box, __assign({ sx: {
                            p: 2,
                            borderBottom: 1,
                            borderColor: "divider",
                            textAlign: "center",
                        } }, { children: _jsx(Typography, __assign({ variant: "h6", sx: { fontWeight: "bold" } }, { children: "Category" })) })), _jsx(Tabs, __assign({ orientation: "vertical", variant: "scrollable", value: value, onChange: handleChange, "aria-label": "Questionnaire Tabs" }, { children: props.titles.map(function (title, num) {
                            var _a;
                            return (_jsx(Tab, __assign({ label: (_a = props.label_mapping[title]) !== null && _a !== void 0 ? _a : title }, a11yProps(num), { sx: tabStyle }), num));
                        }) }))] })), _jsx(Box, __assign({ sx: { flexGrow: 1, width: "100%" } }, { children: props.titles.map(function (_, num) { return (_jsx(TabPanel, __assign({ value: value, index: num }, { children: props.children[num] || "No data available" }), num)); }) }))] })));
}
